import { gql } from '@apollo/client'

const DISH_TYPE_QUERY = gql`
  query dishType($id: ID!) {
    dishType(id: $id) {
      id
      name
      description
      position
      maxPosition
      updatedAt
      isExcludedFromSearch
      isExcludedFromBrowsing

      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
      }

      isIgnored
      courseTypeId
      synonyms
      imageUrl
      processedImageUrl
      iconUrl
      notes

      additionalIngredients {
        id
        type
      }

      alternativeIngredients {
        ingredientId
        alternativeIngredientId
        notes
      }
    }
  }
`

export default DISH_TYPE_QUERY
